export enum BaseReportWindowSteps {
  Client,
  Shift,
  Memo
}
